import { useState } from "react";
import { Power } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function KillSwitch({ killed }) {
  const [busy, setBusy] = useState(false);

  const activate = async () => {
    setBusy(true);
    try {
      await api.kill();
      toast.error("KILL SWITCH ACTIVATED", { description: "All positions squared off. Entries halted." });
    } finally {
      setBusy(false);
    }
  };

  const resume = async () => {
    setBusy(true);
    try {
      await api.resume();
      toast.success("Trading resumed");
    } finally {
      setBusy(false);
    }
  };

  if (killed) {
    return (
      <button
        onClick={resume}
        disabled={busy}
        className="fixed bottom-[76px] left-4 right-4 z-50 mx-auto max-w-md py-4 rounded-sm bg-warn text-black font-black tracking-[0.2em] text-sm active:scale-[0.99] transition-transform duration-150"
        data-testid="resume-btn"
      >
        RESUME TRADING
      </button>
    );
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="fixed bottom-[76px] left-4 right-4 z-50 mx-auto max-w-md py-4 rounded-sm text-white font-black tracking-[0.25em] text-sm kill-glow active:scale-[0.99] transition-transform duration-150 flex items-center justify-center gap-2"
          style={{ background: "#FF2400" }}
          data-testid="kill-switch-btn"
        >
          <Power size={16} strokeWidth={3} /> KILL SWITCH
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-surface border-edge max-w-[340px] rounded-sm" data-testid="kill-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-neg tracking-wide">Activate Kill Switch?</AlertDialogTitle>
          <AlertDialogDescription className="text-muted2">
            This immediately squares off ALL open positions at market and halts new entries for the session.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-elevated border-edge text-white rounded-sm" data-testid="kill-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={activate} disabled={busy} className="bg-kill text-white rounded-sm font-bold" data-testid="kill-confirm">
            KILL EVERYTHING
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
